export default __webpack_public_path__ + "static/media/logo2.ef381713.png";